(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6366],{

/***/ 89301:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app",
      function () {
        return __webpack_require__(97528);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 97528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ app; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/CalendarIcon.js
var CalendarIcon = __webpack_require__(12450);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/SpeakerphoneIcon.js
var SpeakerphoneIcon = __webpack_require__(3268);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/SearchIcon.js
var SearchIcon = __webpack_require__(53737);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/PencilAltIcon.js
var PencilAltIcon = __webpack_require__(37051);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/DotsHorizontalIcon.js
var DotsHorizontalIcon = __webpack_require__(1848);
// EXTERNAL MODULE: ./utils/classes/QuickSearchClass.ts
var QuickSearchClass = __webpack_require__(228);
// EXTERNAL MODULE: ./utils/classes/SidebarClass.ts + 1 modules
var SidebarClass = __webpack_require__(65430);
// EXTERNAL MODULE: ./utils/helperFunctions.ts/meshGradients.ts
var meshGradients = __webpack_require__(18561);
// EXTERNAL MODULE: ./utils/hooks/community/usePrimaryCommunity.ts
var community_usePrimaryCommunity = __webpack_require__(41524);
// EXTERNAL MODULE: ./utils/hooks/self/useSelfInfo.ts
var useSelfInfo = __webpack_require__(76188);
;// CONCATENATED MODULE: ./components/Dashboard/DashboardComponents/MobileDashboardBottomBar.tsx








const MobileBottomButton = (props)=>{
    var ref, ref1;
    const { icon: Icon , onClick , className , active  } = props;
    const router = (0,next_router.useRouter)();
    const colors = (ref = (0,community_usePrimaryCommunity/* usePrimaryCommunity */.a)()) === null || ref === void 0 ? void 0 : (ref1 = ref.communityObject) === null || ref1 === void 0 ? void 0 : ref1.colors;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-10 h-10 relative hover:bg-opacity-50 transition-all rounded-full cursor-pointer group  p-4 dark:text-gray-300",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "z-20 absolute top-0 left-0 p-2 w-full h-full hover:text-".concat(colors === null || colors === void 0 ? void 0 : colors.primary, " ").concat(active && "!text-".concat(colors === null || colors === void 0 ? void 0 : colors.primary, " saturate-[.75]"), " hover:text-opacity-90 hover:bg-gray-100 dark:hover:bg-gray-700 hover:shadow-md rounded-xl transition-all duration-300"),
                children: Icon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "lg:hidden absolute top-1/2 right-0 w-max pointer-events-none translate-x-[calc(100%+2rem)] -translate-y-1/2 bg-gray-900 text-gray-50 p-2 rounded-lg scale-0 group-hover:scale-100 transition-transform origin-left",
                children: "More Options"
            })
        ]
    });
};
const MobileDashboardBottomBar = (props)=>{
    var ref, ref1;
    const { open , setOpen  } = props;
    const colors = (ref = (0,community_usePrimaryCommunity/* usePrimaryCommunity */.a)()) === null || ref === void 0 ? void 0 : (ref1 = ref.communityObject) === null || ref1 === void 0 ? void 0 : ref1.colors;
    const router = (0,next_router.useRouter)();
    const user = (0,useSelfInfo/* useCurrentUser */.x)();
    if (!user) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full h-min hidden md:flex flex-shrink-0 dark:bg-gray-750/80 bg-gray-150 transition-all flex-row gap-2 p-2 shadow-lg z-30  text-gray-600 dark:text-gray-50 relative drop-shadow-lg items-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-grow items-center justify-center gap-6 xs:gap-2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileBottomButton, {
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarIcon/* default */.Z, {}),
                    onClick: ()=>setOpen(0),
                    active: open === 0
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileBottomButton, {
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpeakerphoneIcon/* default */.Z, {}),
                    onClick: ()=>setOpen(1),
                    active: open === 1
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute top-1/4 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-".concat(colors === null || colors === void 0 ? void 0 : colors.primary, " w-16 h-16 cursor-pointer hover:shadow-lg drop-shadow-md transition-all group"),
                    onClick: ()=>{
                        QuickSearchClass/* QuickSearchClass.getInstance */.h.getInstance().setState(true);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full h-full relative p-4 text-gray-50/90 group-hover:text-white drop-shadow-md",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full h-full absolute top-0 left-0 opacity-0 group-hover:opacity-30 transition-all rounded-full",
                                style: {
                                    ...(0,meshGradients/* meshifyColor */.n)(colors === null || colors === void 0 ? void 0 : colors.primary)
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchIcon/* default */.Z, {
                                className: " w-full h-full group-hover:text-shadow z-10"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " rounded-full w-16 h-12 opacity-0 pointer-events-none"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileBottomButton, {
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PencilAltIcon/* default */.Z, {}),
                    onClick: ()=>setOpen(2),
                    active: open === 2
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-10 h-10 relative hover:bg-opacity-50 transition-all rounded-full cursor-pointer group  p-4 dark:text-gray-300",
                    onClick: ()=>{
                        SidebarClass/* SidebarClass.getInstance */.b.getInstance().updateState(true);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "z-20 absolute top-0 left-0 p-2 w-full h-full hover:text-".concat(colors === null || colors === void 0 ? void 0 : colors.primary, " hover:text-opacity-90 hover:bg-gray-100 dark:hover:bg-gray-700 hover:shadow-md rounded-xl transition-all duration-300"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DotsHorizontalIcon/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "lg:hidden absolute top-1/2 right-0 w-max pointer-events-none translate-x-[calc(100%+2rem)] -translate-y-1/2 bg-gray-900 text-gray-50 p-2 rounded-lg scale-0 group-hover:scale-100 transition-transform origin-left",
                            children: "More Options"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var DashboardComponents_MobileDashboardBottomBar = (MobileDashboardBottomBar);

// EXTERNAL MODULE: ./node_modules/localforage/dist/localforage.js
var localforage = __webpack_require__(69483);
var localforage_default = /*#__PURE__*/__webpack_require__.n(localforage);
// EXTERNAL MODULE: ./utils/classes/CourseDataClasses/CourseAnnouncementsDataClass.ts
var CourseAnnouncementsDataClass = __webpack_require__(66313);
// EXTERNAL MODULE: ./utils/classes/Fetcher.ts
var Fetcher = __webpack_require__(69705);
// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(86353);
// EXTERNAL MODULE: ./utils/hooks/community/useCommunityCourses.ts
var useCommunityCourses = __webpack_require__(74398);
;// CONCATENATED MODULE: ./utils/hooks/course/useAllSchoolAnnouncements.ts







const useAllSchoolAnnouncements = function(communityID) {
    let cachable = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    const [schoolAnnouncements, setSchoolAnnouncements] = (0,react.useState)(null);
    const courses = (0,useCommunityCourses/* useCommunityCourses */.O)(communityID);
    const user = (0,useSelfInfo/* useCurrentUser */.x)();
    (0,react.useEffect)(()=>{
        if (!courses || !courses.size) return;
        console.log("useAllSchoolAnnouncementsDeps:", courses, user, cachable);
        const schoolAnnouncementsMap = new Map();
        let schoolwideAnnouncements = new Map();
        let cancels = [];
        let clog = 0;
        let lastUpdate = 0;
        let updateQueued = false;
        const updateAnnouncements = ()=>{
            if (lastUpdate > Date.now() - 500) {
                if (updateQueued) return;
                updateQueued = true;
                setTimeout(()=>{
                    updateQueued = false;
                    updateAnnouncements();
                }, 500);
                return;
            }
            lastUpdate = Date.now();
            // merge all course announcements into one array
            const announcements = [];
            courses.forEach((course)=>{
                var ref;
                announcements.push(...Array.from((ref = schoolAnnouncementsMap.get(course.id)) !== null && ref !== void 0 ? ref : []).map((a)=>({
                        ...a,
                        courseID: course.id,
                        course: course
                    })));
            });
            announcements.push(...Array.from((schoolwideAnnouncements === null || schoolwideAnnouncements === void 0 ? void 0 : schoolwideAnnouncements.values()) || []));
            announcements.sort((a, b)=>b.created - a.created);
            const oldThreshold = Date.now() - 1000 * 60 * 60 * 24 * 14;
            // const notOld = announcements.findIndex(a => a.created >= oldThreshold)
            setSchoolAnnouncements(announcements.slice(0, 50));
            console.log("update", clog++, announcements.length);
        // console.log('announcements', announcements.slice(0, Math.min(~notOld ? notOld: 20, 20)), notOld,20)
        };
        localforage_default().getItem("community.".concat(user === null || user === void 0 ? void 0 : user.primaryCommunity, ".schoolAnnouncements")).then((data)=>{
            console.log("schoolAnnouncements", data);
            const map = data;
            Array.from((map === null || map === void 0 ? void 0 : map.values()) || []).forEach((announcement)=>{
                schoolwideAnnouncements.set(announcement.id, announcement);
            });
            updateAnnouncements();
        });
        courses.forEach((course)=>{
            const schoolAnnouncements = CourseAnnouncementsDataClass/* CourseAnnouncementsDataClass.getInstance */.X.getInstance(course.id).announcements;
            schoolAnnouncementsMap.set(course.id, new Set(schoolAnnouncements));
            const setAnnouncements = (event)=>{
                const announcementSet = schoolAnnouncementsMap.get(course.id);
                if (announcementSet) {
                    CourseAnnouncementsDataClass/* CourseAnnouncementsDataClass.getInstance */.X.getInstance(course.id).announcements.forEach((announcement)=>{
                        announcementSet.add(announcement);
                    });
                }
                // schoolAnnouncementsMap.set(course.id, new Set(event.announcements))
                updateAnnouncements();
            };
            CourseAnnouncementsDataClass/* CourseAnnouncementsDataClass.getInstance */.X.getInstance(course.id).on("announcementsUpdate", setAnnouncements);
            cancels.push(()=>{
                CourseAnnouncementsDataClass/* CourseAnnouncementsDataClass.getInstance */.X.getInstance(course.id).off("announcementsUpdate", setAnnouncements);
            });
        });
        updateAnnouncements();
        (0,Fetcher/* fetcher */._)("".concat(constants/* API_DOMAIN */.hW, "/community/").concat(user === null || user === void 0 ? void 0 : user.primaryCommunity, "/LMS/announcements?fresh=1"), undefined, "important").then((res)=>res.ok ? res.json() : null).then((res)=>res && res.announcements.forEach((a)=>{
                schoolwideAnnouncements.set(a.id, {
                    ...a,
                    school: true
                });
            })).then((x)=>{
            //   console.log('schoolwide announcements', schoolwideAnnouncements))
            localforage_default().setItem("community.".concat(user === null || user === void 0 ? void 0 : user.primaryCommunity, ".schoolAnnouncements"), schoolwideAnnouncements);
            updateAnnouncements();
        });
        return ()=>{
            cancels.forEach((cancel)=>cancel());
        };
    }, [
        JSON.stringify(Array.from((courses === null || courses === void 0 ? void 0 : courses.values()) || [])),
        cachable,
        JSON.stringify(user)
    ]);
    return schoolAnnouncements;
};

// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/utc.js
var utc = __webpack_require__(70178);
var utc_default = /*#__PURE__*/__webpack_require__.n(utc);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/relativeTime.js
var relativeTime = __webpack_require__(84110);
var relativeTime_default = /*#__PURE__*/__webpack_require__.n(relativeTime);
// EXTERNAL MODULE: ./node_modules/remove-markdown/index.js
var remove_markdown = __webpack_require__(26525);
var remove_markdown_default = /*#__PURE__*/__webpack_require__.n(remove_markdown);
// EXTERNAL MODULE: ./components/Dashboard/DashboardComponents/Announcements/AnnouncementModal.tsx
var AnnouncementModal = __webpack_require__(47853);
// EXTERNAL MODULE: ./utils/hooks/customization/colors.tsx
var colors = __webpack_require__(42856);
;// CONCATENATED MODULE: ./components/Dashboard/DashboardComponents/Announcements/Announcement.tsx




dayjs_min_default().extend((utc_default()));
dayjs_min_default().extend((relativeTime_default()));






const DashboardAnnouncementViewer = (props)=>{
    const { announcement  } = props;
    const community = (0,community_usePrimaryCommunity/* usePrimaryCommunity */.a)();
    const [openPopup, setOpenPopup] = (0,react.useState)(false);
    const router = (0,next_router.useRouter)();
    const course = router.query.course;
    var _body;
    const parsed = remove_markdown_default()((_body = announcement.body) !== null && _body !== void 0 ? _body : "", {
        stripListLeaders: true,
        gfm: false
    });
    const color = (0,colors/* useUserColors */.t)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-2 p-4 dark:bg-gray-800/80 backdrop-blur-md bg-gray-100/70 shadow-sm rounded-xl w-full transition-all ease-out duration-150 cursor-pointer flex-shrink-0 group",
                onClick: (e)=>{
                    // setShowmore(!showmore)
                    setOpenPopup(true);
                    e.stopPropagation();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row gap-4 justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row gap-2 items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "w-8 h-8 rounded-lg object-cover",
                                        src: announcement.user.picture
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-sm dark:text-gray-500",
                                            children: announcement.user.name
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-xs dark:text-gray-500",
                                    children: dayjs_min_default()(announcement.created).fromNow()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-2 flex-grow",
                        children: [
                            announcement.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: announcement.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative h-36 2xl:h-[4.5rem] w-full line-clamp-6 leading-6",
                                children: parsed
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row justify-between items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-gray-400 group-hover:text-".concat(color, " cursor-pointer transition-all duration-150 "),
                                        children: "Preview"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "text-xs dark:text-gray-500 text-gray-700/40",
                                        children: [
                                            dayjs_min_default()(announcement.created).format("MMMM DD YYYY"),
                                            " at ",
                                            dayjs_min_default()(announcement.created).format("hh:mm A")
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, "".concat(announcement.id, "-").concat(announcement.body)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnnouncementModal/* AnnouncementModal */.k, {
                announcement: announcement,
                open: openPopup,
                onClose: ()=>setOpenPopup(false)
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Dashboard/DashboardComponents/Announcements/Announcements.tsx




const ToggleButton = (props)=>{
    var ref, ref1;
    const { icon: Icon , onClick , className , active  } = props;
    const colors = (ref = usePrimaryCommunity()) === null || ref === void 0 ? void 0 : (ref1 = ref.communityObject) === null || ref1 === void 0 ? void 0 : ref1.colors;
    return /*#__PURE__*/ _jsx("div", {
        className: "w-10 h-10 relative hover:bg-opacity-50 transition-all rounded-full cursor-pointer group  p-4 dark:text-gray-300",
        onClick: onClick,
        children: /*#__PURE__*/ _jsx("div", {
            className: "z-20 absolute top-0 left-0 p-2 w-full h-full hover:text-".concat(colors === null || colors === void 0 ? void 0 : colors.primary, " ").concat(active && "!text-".concat(colors === null || colors === void 0 ? void 0 : colors.primary, " saturate-[.75]"), " hover:text-opacity-90 hover:bg-gray-100 dark:hover:bg-gray-700 hover:shadow-md rounded-xl transition-all duration-300"),
            children: Icon
        })
    });
};
const DashboardAnnouncements = (props)=>{
    const { open , setOpen  } = props;
    const community = (0,community_usePrimaryCommunity/* usePrimaryCommunity */.a)();
    const announcements = useAllSchoolAnnouncements(community === null || community === void 0 ? void 0 : community.community, undefined);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-8 pt-16 w-full h-full p-4 2xl:hidden md:flex",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-row justify-between pr-2 items-center z-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "text-2xl font-bold text-gray-100",
                    children: "Latest Announcements"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative flex-grow",
                children: [
                    !(announcements === null || announcements === void 0 ? void 0 : announcements.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-col gap-4 items-center justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "No Announcements"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 left-0 w-full h-full flex flex-col gap-4 overflow-auto",
                        children: announcements === null || announcements === void 0 ? void 0 : announcements.map((announcement)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardAnnouncementViewer, {
                                announcement: announcement
                            }))
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Dashboard/DashboardComponents/Background.tsx




const DashboardBackground = ()=>{
    const user = (0,useSelfInfo/* useCurrentUser */.x)(true);
    const [hue, setHue] = (0,react.useState)(0);
    const [bg, setBg] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        if (user) {
            switch(user.theme){
                case 0:
                    setBg("/defaults/background/light.png");
                case 1:
                    setBg("/defaults/background/dark.png");
                    break;
                case 2:
                    setBg("/kimikoBG.png");
                    break;
                default:
                    setBg("/defaults/background/dark.png");
                    break;
            }
        }
    }, [
        user
    ]);
    const community = (0,community_usePrimaryCommunity/* usePrimaryCommunity */.a)();
    // alert(defaultBG)
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full h-full bg-cover bg-center absolute top-0 left-0",
        style: {
            backgroundImage: "url(".concat(bg, ")"),
            filter: "hue-rotate(".concat(hue, "deg)")
        }
    });
};

// EXTERNAL MODULE: ./utils/classes/CourseDataClasses/CourseAssignmentDataClass.ts
var CourseAssignmentDataClass = __webpack_require__(56596);
;// CONCATENATED MODULE: ./utils/hooks/course/useAllCourseUpcoming.ts
var _this = undefined;




const useAllCourseUpcoming = function(communityID) {
    let cachable = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, ignore = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    const [courseUpcoming, setCourseUpcoming] = (0,react.useState)(undefined);
    const courses = (0,useCommunityCourses/* useCommunityCourses */.O)(communityID);
    const comm = (0,community_usePrimaryCommunity/* usePrimaryCommunity */.a)();
    const cIDs = (0,react.useRef)();
    (0,react.useEffect)(()=>{
        if (!courses || !(comm === null || comm === void 0 ? void 0 : comm.courses)) return;
        if (courses.size !== Object.keys(comm.courses).length) return;
        const generatedcIDs = JSON.stringify(Array.from(courses.keys()).sort((a, b)=>a.localeCompare(b)));
        if (cIDs.current === generatedcIDs) return;
        cIDs.current = generatedcIDs;
        const courseUpcomingMap = new Map();
        let cancels = [];
        const updateUpcoming = ()=>{
            // merge all course upcomings into one array
            const upcomings = [];
            courses.forEach((course)=>{
                var ref;
                upcomings.push(...(ref = courseUpcomingMap.get(course.id)) !== null && ref !== void 0 ? ref : []);
            });
            upcomings.sort((a, b)=>a.start - b.start);
            const oldThreshold = Date.now() - 1000 * 60 * 60 * 24 * 14 // 2 weeks ago
            ;
            const notOld = upcomings.findIndex((a)=>a.start >= Date.now());
            setCourseUpcoming(upcomings.slice(notOld, notOld + 20));
        };
        courses.forEach((course)=>{
            var ref;
            const courseUpcoming = CourseAssignmentDataClass/* CourseMaterialsDataClass.getInstance */.C.getInstance(course.id).upcomingEvents && Array.from(((ref = CourseAssignmentDataClass/* CourseMaterialsDataClass.getInstance */.C.getInstance(course.id).upcomingEvents) === null || ref === void 0 ? void 0 : ref.values()) || []).map((e)=>({
                    ...e,
                    course: course
                }));
            if (courseUpcoming) {
                courseUpcomingMap.set(course.id, new Set(courseUpcoming));
            }
            const setUpcomings = (event)=>{
                var ref;
                // console.warn("Upcoming update",)
                const courseUpcoming = CourseAssignmentDataClass/* CourseMaterialsDataClass.getInstance */.C.getInstance(course.id).upcomingEvents && Array.from(((ref = CourseAssignmentDataClass/* CourseMaterialsDataClass.getInstance */.C.getInstance(course.id).upcomingEvents) === null || ref === void 0 ? void 0 : ref.values()) || []).map((e)=>({
                        ...e,
                        course: course
                    }));
                if (courseUpcoming) {
                    courseUpcomingMap.set(course.id, new Set(courseUpcoming));
                }
                updateUpcoming();
            };
            // CourseMaterialsDataClass.getInstance(course.id).on('upcomingEventsUpdate', (e)=>console.warn("Upcoming update",e))
            CourseAssignmentDataClass/* CourseMaterialsDataClass.getInstance */.C.getInstance(course.id).on("upcomingEventsUpdate", setUpcomings.bind(_this));
            cancels.push(()=>{
                CourseAssignmentDataClass/* CourseMaterialsDataClass.getInstance */.C.getInstance(course.id).off("upcomingEventsUpdate", setUpcomings);
            });
            !CourseAssignmentDataClass/* CourseMaterialsDataClass.getInstance */.C.getInstance(course.id).fetchingUpcoming && CourseAssignmentDataClass/* CourseMaterialsDataClass.getInstance */.C.getInstance(course.id).getUpcomingEvents();
        });
        updateUpcoming();
        return ()=>{
            cancels.forEach((cancel)=>cancel());
        };
    }, [
        comm,
        courses,
        cachable,
        ignore
    ]);
    // console.log("courseUpcoming",courseUpcoming)
    return courseUpcoming;
};

;// CONCATENATED MODULE: ./components/Dashboard/DashboardComponents/EventsInfo/UpcomingEvent/Event.tsx







const DashboardUpcomingViewer = (props)=>{
    var ref, ref1;
    const { event  } = props;
    const community = (0,community_usePrimaryCommunity/* usePrimaryCommunity */.a)();
    const [openPopup, setOpenPopup] = (0,react.useState)(false);
    const router = (0,next_router.useRouter)();
    var _description;
    const parsed = remove_markdown_default()((_description = event.description) !== null && _description !== void 0 ? _description : "", {
        stripListLeaders: true,
        gfm: false
    });
    const color = (0,colors/* useUserColors */.t)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col gap-2 p-4 dark:bg-gray-800/80 backdrop-blur-md bg-gray-100/70 shadow-sm rounded-xl w-full transition-all ease-out duration-150 cursor-pointer flex-shrink-0 group",
            onClick: (e)=>{
                // setShowmore(!showmore)
                if (event.type === "assignment") {
                    var ref;
                    router.push("/app/courses/".concat((ref = event.course) === null || ref === void 0 ? void 0 : ref.id, "/materials/").concat(event.assignmentID));
                    return;
                }
                setOpenPopup(true);
                e.stopPropagation();
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row gap-4 justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-row gap-2 items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "w-8 h-8 rounded-lg object-cover",
                                    src: (ref = event.course) === null || ref === void 0 ? void 0 : ref.icon
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-sm dark:text-gray-500",
                                        children: (ref1 = event.course) === null || ref1 === void 0 ? void 0 : ref1.name
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-xs dark:text-gray-500",
                                children: dayjs_min_default()(event.start).fromNow()
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col gap-2 flex-grow",
                    children: [
                        event.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "font-bold leading-6 text-gray-800 dark:text-gray-150",
                            children: event.title
                        }),
                        !!parsed.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative h-18 2xl:h-[4.5rem] w-full line-clamp-3 leading-6",
                            children: parsed
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-row justify-between items-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-gray-400 group-hover:text-".concat(color, " cursor-pointer transition-all duration-150 "),
                                children: "Preview"
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/Dashboard/DashboardComponents/EventsInfo/Events.tsx




const DashboardUpcoming = (props)=>{
    const { open , setOpen  } = props;
    const community = (0,community_usePrimaryCommunity/* usePrimaryCommunity */.a)();
    const upcoming = useAllCourseUpcoming(community === null || community === void 0 ? void 0 : community.community);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-8 pt-16 w-full h-full p-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-row justify-between pr-2 items-center z-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "text-2xl font-bold  text-gray-100",
                    children: "Upcoming"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative flex-grow",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute top-0 left-0 w-full h-full flex flex-col gap-4 overflow-auto",
                    children: upcoming === null || upcoming === void 0 ? void 0 : upcoming.map((event)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardUpcomingViewer, {
                            event: event
                        }))
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./utils/tailwindHelpers/getBreakpoint.ts
var getBreakpoint = __webpack_require__(54175);
;// CONCATENATED MODULE: ./components/Dashboard/DashboardComponents/MixxedAnnouncementsAndUpcoming.tsx








const MixxedAnnouncementsAndUpcoming_ToggleButton = (props)=>{
    var ref, ref1;
    const { icon: Icon , onClick , className , active  } = props;
    const colors = (ref = (0,community_usePrimaryCommunity/* usePrimaryCommunity */.a)()) === null || ref === void 0 ? void 0 : (ref1 = ref.communityObject) === null || ref1 === void 0 ? void 0 : ref1.colors;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-10 h-10 relative hover:bg-opacity-50 transition-all rounded-full cursor-pointer group  p-4 dark:text-gray-300",
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "z-20 absolute top-0 left-0 p-2 w-full h-full hover:text-".concat(colors === null || colors === void 0 ? void 0 : colors.primary, " ").concat(active && "!text-".concat(colors === null || colors === void 0 ? void 0 : colors.primary, " saturate-[.75]"), " hover:text-opacity-90 hover:bg-gray-100 dark:hover:bg-gray-700 hover:shadow-md rounded-xl transition-all duration-300"),
            children: Icon
        })
    });
};
const MixedDashboardAndUpcoming = (props)=>{
    const { open , setOpen  } = props;
    const community = (0,community_usePrimaryCommunity/* usePrimaryCommunity */.a)();
    const announcements = useAllSchoolAnnouncements(community === null || community === void 0 ? void 0 : community.community);
    const upcoming = useAllCourseUpcoming(community === null || community === void 0 ? void 0 : community.community, undefined, (0,getBreakpoint/* screenSmallerThan */.k)("lg"));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex-col gap-8 pt-16 w-full h-full p-4 2xl:flex hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row justify-between pr-2 items-center z-20",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "text-2xl font-bold text-gray-100 ".concat(open !== 2 ? "2xl:block md:hidden" : "2xl:hidden inf:block"),
                        children: "Latest Announcements"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "text-2xl font-bold text-gray-100 ".concat(open === 2 ? "2xl:block inf:hidden  md:hidden" : "hidden"),
                        children: "Assignments Info"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "p-2 dark:bg-gray-850/70 bg-gray-150/70 backdrop-blur-lg xl:flex-row gap-2 rounded-xl 2xl:flex md:hidden hidden",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MixxedAnnouncementsAndUpcoming_ToggleButton, {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpeakerphoneIcon/* default */.Z, {}),
                                onClick: ()=>setOpen(1),
                                active: open !== 2
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MixxedAnnouncementsAndUpcoming_ToggleButton, {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PencilAltIcon/* default */.Z, {}),
                                onClick: ()=>setOpen(2),
                                active: open === 2
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative flex-grow",
                children: [
                    open === 2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: !(upcoming === null || upcoming === void 0 ? void 0 : upcoming.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col gap-4 items-center justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "No Upcoming Events"
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: !(announcements === null || announcements === void 0 ? void 0 : announcements.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col gap-4 items-center justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "No Announcements"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "absolute top-0 left-0 w-full h-full flex flex-col gap-4 overflow-auto",
                        children: [
                            open !== 2 && (announcements === null || announcements === void 0 ? void 0 : announcements.map((announcement)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardAnnouncementViewer, {
                                    announcement: announcement
                                }))),
                            open === 2 && (upcoming === null || upcoming === void 0 ? void 0 : upcoming.map((event)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardUpcomingViewer, {
                                    event: event
                                })))
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./utils/classes/ScheduleClass.ts + 1 modules
var ScheduleClass = __webpack_require__(75344);
// EXTERNAL MODULE: ./utils/hooks/schedule/useMasterSchedule.ts
var useMasterSchedule = __webpack_require__(6734);
// EXTERNAL MODULE: ./utils/hooks/schedule/useUserSchedulePrefs.ts
var useUserSchedulePrefs = __webpack_require__(39575);
;// CONCATENATED MODULE: ./components/Dashboard/DashboardComponents/Schedule/CurrentClass.tsx









const epochify = (x)=>{
    const d = new Date();
    d.setHours(0);
    d.setMinutes(0);
    d.setSeconds(0);
    d.setMilliseconds(0);
    return d.getTime() + x;
// changes ms past midnight to ms past epoch
};
const formatTime = (x)=>~~Math.abs((epochify(x) - Date.now()) / 1000) <= 100 ? ~~((epochify(x) - Date.now()) / 1000) : ~~Math.abs((epochify(x) - Date.now()) / 1000 / 60) <= 130 ? ~~((epochify(x) - Date.now()) / 1000 / 60) : ~~Math.abs((epochify(x) - Date.now()) / 1000 / 60 / 60);
const timeUnits = (x)=>{
    const secs = x / 1000;
    if (secs < 100) {
        return "seconds";
    } else if (secs < 60 * 130) {
        return "minutes ";
    } else {
        return "hours";
    }
};
const CurrentClassSchedule = ()=>{
    var ref, ref1, ref2, ref3;
    const community = (0,community_usePrimaryCommunity/* usePrimaryCommunity */.a)();
    const courses = (0,useCommunityCourses/* useCommunityCourses */.O)(community === null || community === void 0 ? void 0 : community.community);
    const masterSchedule = (0,useMasterSchedule/* useMasterSchedule */.I)(community === null || community === void 0 ? void 0 : community.community);
    const schedulePrefs = (0,useUserSchedulePrefs/* useUserSchedule */.W)(community === null || community === void 0 ? void 0 : community.community);
    const [scheduleDay, setScheduleDay] = (0,react.useState)(null);
    const [tick, setTick] = (0,react.useState)(0);
    const color = (0,colors/* useUserColors */.t)();
    (0,react.useEffect)(()=>{
        const update = ()=>{
            ScheduleClass/* ScheduleClass.getInstance */.L.getInstance().parseScheduleDay(masterSchedule !== null && masterSchedule !== void 0 ? masterSchedule : undefined).then((day)=>{
                setScheduleDay(day !== null && day !== void 0 ? day : null);
            });
        };
        update();
        const interval = setInterval(()=>{
            update();
        }, 1000);
        return ()=>clearInterval(interval);
    //TODO - update scheduleDay when midnight is reached
    }, [
        masterSchedule,
        schedulePrefs
    ]);
    (0,react.useEffect)(()=>{
        const refresh = setInterval(()=>{
            setTick((t)=>(t + 1) % 10);
        }, 1000);
        return ()=>{
            clearInterval(refresh);
        };
    }, []);
    const currentClass = (0,react.useMemo)(()=>{
        if (!scheduleDay) {
            return null;
        }
        const blacklistedPeriods = new Set();
        schedulePrefs === null || schedulePrefs === void 0 ? void 0 : schedulePrefs.classes.map((classPref)=>classPref.type === "prep" && blacklistedPeriods.add(classPref.periodID));
        const cleanedScheduleDay = scheduleDay.filter((x)=>x.period && !blacklistedPeriods.has(x.period));
        const currentPeriod = cleanedScheduleDay.find((x)=>epochify(x.from) <= Date.now() && epochify(x.to) >= Date.now());
        if (!currentPeriod) {
            const nextPeriod = cleanedScheduleDay.filter((x)=>epochify(x.from) >= Date.now()).sort((a, b)=>a.from - b.from)[0];
            if (!nextPeriod) {
                const prevPeriod = cleanedScheduleDay.filter((x)=>epochify(x.to) <= Date.now()).sort((a, b)=>b.to - a.to)[0];
                return {
                    period: prevPeriod,
                    type: "prev"
                };
            }
            return {
                period: nextPeriod,
                type: "next"
            };
        }
        return {
            period: currentPeriod,
            type: "current"
        };
    }, [
        scheduleDay,
        masterSchedule,
        schedulePrefs,
        tick
    ]);
    const scheduleClassOverride = (schedulePrefs === null || schedulePrefs === void 0 ? void 0 : (ref = schedulePrefs.classes) === null || ref === void 0 ? void 0 : ref.find((x)=>{
        var ref;
        return (x === null || x === void 0 ? void 0 : x.periodID) === (currentClass === null || currentClass === void 0 ? void 0 : (ref = currentClass.period) === null || ref === void 0 ? void 0 : ref.period);
    })) || {
        type: "custom",
        name: masterSchedule === null || masterSchedule === void 0 ? void 0 : (ref2 = masterSchedule.periods) === null || ref2 === void 0 ? void 0 : ref2[(currentClass === null || currentClass === void 0 ? void 0 : (ref1 = currentClass.period) === null || ref1 === void 0 ? void 0 : ref1.period) || ""]
    };
    if (!(currentClass === null || currentClass === void 0 ? void 0 : (ref3 = currentClass.period) === null || ref3 === void 0 ? void 0 : ref3.period)) return null;
    // if (!scheduleClassOverride) return null
    const userClass = (()=>{
        switch(scheduleClassOverride === null || scheduleClassOverride === void 0 ? void 0 : scheduleClassOverride.type){
            case "class":
                var ref, ref1;
                return {
                    name: (ref = courses === null || courses === void 0 ? void 0 : courses.get(scheduleClassOverride.class)) === null || ref === void 0 ? void 0 : ref.name,
                    link: "/app/courses/".concat((ref1 = courses === null || courses === void 0 ? void 0 : courses.get(scheduleClassOverride.class)) === null || ref1 === void 0 ? void 0 : ref1.id)
                };
            case "custom":
                return {
                    name: scheduleClassOverride === null || scheduleClassOverride === void 0 ? void 0 : scheduleClassOverride.name,
                    link: null
                };
            default:
                return {
                    name: "".concat(scheduleClassOverride === null || scheduleClassOverride === void 0 ? void 0 : scheduleClassOverride.type),
                    link: null
                };
        }
    })();
    const completion = (epochify(currentClass === null || currentClass === void 0 ? void 0 : currentClass.period.to) - Date.now()) / ((currentClass === null || currentClass === void 0 ? void 0 : currentClass.period.to) - (currentClass === null || currentClass === void 0 ? void 0 : currentClass.period.from));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full flex flex-col p-6 pb-6 gap-8",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-row items-center justify-end gap-4 dark:text-gray-200/70 text-gray-100/70",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-end gap-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: userClass.link || "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-3xl font-bold text-white text-shadow-sm -0 underline-offset-2 hover:text-".concat(color, " transition-all cursor-pointer font-montserrat font-black text-right"),
                                children: userClass.name
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "",
                            children: [
                                (currentClass === null || currentClass === void 0 ? void 0 : currentClass.type) === "current" && "ends in",
                                (currentClass === null || currentClass === void 0 ? void 0 : currentClass.type) === "next" && "starts in",
                                (currentClass === null || currentClass === void 0 ? void 0 : currentClass.type) === "prev" && "ended"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "  flex flex-row justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative w-32 h-32",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                className: "absolute top-0 left-0 z-20 w-full h-full -rotate-90 rounded-full",
                                viewBox: "0 0 240 240",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                        className: "rounded-full stroke-gray-800/70 ",
                                        stroke: "white",
                                        strokeWidth: "22",
                                        fill: "transparent",
                                        r: "104",
                                        cx: "120",
                                        cy: "120"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                        className: "rounded-full stroke-".concat(color, " transition-all"),
                                        stroke: "white",
                                        strokeWidth: "22",
                                        strokeDasharray: "".concat(Math.PI * 208, " ").concat(Math.PI * 208),
                                        strokeDashoffset: "".concat(Math.PI * 208 * completion),
                                        strokeLinecap: "round",
                                        fill: "transparent",
                                        r: "104",
                                        cx: "120",
                                        cy: "120"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 w-[95%] h-[95%] backdrop-blur-md rounded-full"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 p-2 flex flex-col items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-3xl font-bold text-shadow-sm text-".concat(color),
                                        children: (currentClass === null || currentClass === void 0 ? void 0 : currentClass.type) === "next" ? formatTime(currentClass.period.from) : formatTime(currentClass === null || currentClass === void 0 ? void 0 : currentClass.period.to)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "text-base font-medium text-shadow-sm text-gray-100",
                                        children: [
                                            (currentClass === null || currentClass === void 0 ? void 0 : currentClass.type) === "next" && timeUnits(Math.abs(epochify(currentClass === null || currentClass === void 0 ? void 0 : currentClass.period.from) - Date.now())),
                                            (currentClass === null || currentClass === void 0 ? void 0 : currentClass.type) === "current" && timeUnits(Math.abs(epochify(currentClass === null || currentClass === void 0 ? void 0 : currentClass.period.to) - Date.now())),
                                            (currentClass === null || currentClass === void 0 ? void 0 : currentClass.type) === "prev" && timeUnits(Math.abs(epochify(currentClass === null || currentClass === void 0 ? void 0 : currentClass.period.to) - Date.now()))
                                        ]
                                    }),
                                    epochify(currentClass === null || currentClass === void 0 ? void 0 : currentClass.period.to) - Date.now() < 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-sm font-medium text-shadow-sm text-gray-100",
                                        children: "ago"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./utils/hooks/course/useCourse.ts
var useCourse = __webpack_require__(72817);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/ClockIcon.js
var ClockIcon = __webpack_require__(15186);
// EXTERNAL MODULE: ./utils/useForceUpdate.ts
var useForceUpdate = __webpack_require__(84248);
;// CONCATENATED MODULE: ./components/Dashboard/DashboardComponents/Schedule/DaySchedule/ClassBlockTypes/GenericBlockTemplate.tsx






const convertTime = (msFromMidnight)=>{
    const hours = Math.floor(msFromMidnight / 3600000);
    const minutes = Math.floor(msFromMidnight % 3600000 / 60000);
    const seconds = Math.floor(msFromMidnight % 60000 / 1000);
    const time = "".concat(String(hours > 12 ? hours - 12 : hours).padStart(2, "0"), ":").concat(String(minutes).padStart(2, "0"), " ").concat(hours >= 12 ? "PM" : "AM");
    return time;
};
const GenericBlockTemplate_epochify = (x)=>{
    const d = new Date();
    d.setHours(0);
    d.setMinutes(0);
    d.setSeconds(0);
    d.setMilliseconds(0);
    return d.getTime() + x;
// changes ms past midnight to ms past epoch
};
const convertMsToTime = (ms)=>{
    const hours = Math.floor(ms / 3600000);
    const minutes = Math.floor(ms % 3600000 / 60000);
    const seconds = Math.floor(ms % 60000 / 1000);
    // less than 2 hours return minutes
    if (ms / 3600000 < 2) {
        return "".concat(minutes + 60 * hours, " mins");
    }
    // less than 2 minutes return seconds
    if (ms / 60000 < 2) {
        return "".concat(seconds, " secs");
    }
    // more than 2 hours return hours
    return "".concat(hours, " hrs");
};
const GenericBlockTemplate = (props)=>{
    const { name , caption , image , start , end  } = props;
    const update = (0,useForceUpdate/* default */.Z)();
    (0,react.useEffect)(()=>{
        const startTime = GenericBlockTemplate_epochify(start) > Date.now() && setTimeout(()=>{
            update();
        }, GenericBlockTemplate_epochify(start) - Date.now() + 250);
        const endTime = GenericBlockTemplate_epochify(end) > Date.now() && setTimeout(()=>{
            update();
        }, GenericBlockTemplate_epochify(end) - Date.now() + 250);
        return ()=>{
            startTime && clearTimeout(startTime);
            endTime && clearTimeout(endTime);
        };
    }, [
        end,
        start
    ]);
    const community = (0,community_usePrimaryCommunity/* usePrimaryCommunity */.a)();
    const color = (0,colors/* useUserColors */.t)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full px-4",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-full h-[7.5rem] flex-shrink-0 dark:bg-gray-800 bg-gray-100 dark:bg-opacity-70 bg-opacity-70 backdrop-blur-md p-4 rounded-lg shadow-md relative ".concat(Date.now() >= GenericBlockTemplate_epochify(end) && "bg-opacity-30 dark:brightness-75 dark:hover:brightness-100 hover:bg-opacity-50", " transition-all cursor-pointer hover:brightness-110"),
            onClick: ()=>{},
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-".concat(color, " border-opacity-50 w-full h-full absolute z-0 top-0 left-0 rounded-lg bg-opacity-30 transition-all ").concat(Date.now() >= GenericBlockTemplate_epochify(start) && Date.now() <= GenericBlockTemplate_epochify(end) ? "opacity-30" : "opacity-0")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "absolute top-0 left-0 w-full h-full p-4 flex flex-col gap-2 items-start z-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-row gap-4 items-center w-full",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-14 h-full flex-shrink-0 flex flex-col gap-2 items-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-14 h-14 flex items-center justify-center flex-shrink-0 rounded-lg overflow-auto",
                                        children: typeof image === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: image,
                                            className: "w-full h-full object-center object-cover"
                                        }) : image
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex-grow h-full flex flex-col relative",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "absolute top-0 left-0 w-full h-full flex flex-col ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-bold text-2xl font-montserrat ".concat(Date.now() >= GenericBlockTemplate_epochify(start) && Date.now() <= GenericBlockTemplate_epochify(end) ? "text-".concat(color) : "text-gray-800/80 dark:text-gray-250", " truncate"),
                                                children: name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-base font-wsans dark:text-gray-300",
                                                children: caption
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-row items-center gap-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "dark:text-gray-100/40 w-16",
                                    children: convertMsToTime(end - start)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: !!start && !!end && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row items-center gap-2 dark:text-gray-100/60",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClockIcon/* default */.Z, {
                                                className: "w-4 h-4"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "text-base font-wsans",
                                                children: [
                                                    convertTime(start),
                                                    " – ",
                                                    convertTime(end)
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/Dashboard/DashboardComponents/Schedule/DaySchedule/ClassBlockTypes/ClassClassBlock.tsx





const ClassClassBlock = (props)=>{
    const { classBlock , sb  } = props;
    const community = (0,community_usePrimaryCommunity/* usePrimaryCommunity */.a)();
    const schedule = (0,useMasterSchedule/* useMasterSchedule */.I)(community === null || community === void 0 ? void 0 : community.community);
    const course = (0,useCourse/* useCourse */.T)(classBlock.class, undefined, true);
    if (!course) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericBlockTemplate, {
        name: course.name,
        caption: schedule === null || schedule === void 0 ? void 0 : schedule.periods[classBlock.periodID],
        image: course.icon,
        start: sb.from,
        end: sb.to
    });
};

;// CONCATENATED MODULE: ./components/Dashboard/DashboardComponents/Schedule/DaySchedule/ClassBlockTypes/CustomClassBlock.tsx








const CustomClassBlock = (props)=>{
    const { classBlock , sb  } = props;
    const community = (0,community_usePrimaryCommunity/* usePrimaryCommunity */.a)();
    const schedule = (0,useMasterSchedule/* useMasterSchedule */.I)(community === null || community === void 0 ? void 0 : community.community);
    const user = (0,useSelfInfo/* useCurrentUser */.x)(true);
    const src = (0,react.useMemo)(()=>{
        if ((user === null || user === void 0 ? void 0 : user.theme) === 2) return "https://cdn.discordapp.com/attachments/957350482639212545/1062216659575767130/CroppedKimiko.png";
        return "logo.png";
    }, [
        user === null || user === void 0 ? void 0 : user.theme
    ]);
    const color = (0,colors/* useUserColors */.t)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericBlockTemplate, {
        name: classBlock.name,
        caption: schedule === null || schedule === void 0 ? void 0 : schedule.periods[classBlock.periodID],
        image: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-full h-full brightness-90 flex flex-row items-center justify-center relative",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute top-0 left-0 w-full h-full blur-lg",
                    style: {
                        ...(0,meshGradients/* meshifyColor */.n)(color)
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: src,
                    className: "w-12 h-12 grayscale-[0.5]"
                })
            ]
        }),
        start: sb.from,
        end: sb.to
    });
};

// EXTERNAL MODULE: ./node_modules/react-icons/bi/index.esm.js
var index_esm = __webpack_require__(47516);
;// CONCATENATED MODULE: ./components/Dashboard/DashboardComponents/Schedule/DaySchedule/ClassBlockTypes/PrepBlock.tsx








const PrepClassBlock = (props)=>{
    var ref;
    const { classBlock , sb  } = props;
    const community = (0,community_usePrimaryCommunity/* usePrimaryCommunity */.a)();
    const schedule = (0,useMasterSchedule/* useMasterSchedule */.I)(community === null || community === void 0 ? void 0 : community.community);
    const userOptions = (0,useUserSchedulePrefs/* useUserSchedule */.W)(community === null || community === void 0 ? void 0 : community.community);
    const color = (0,colors/* useUserColors */.t)();
    if (userOptions === null || userOptions === void 0 ? void 0 : (ref = userOptions.options) === null || ref === void 0 ? void 0 : ref.showPreps) return /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericBlockTemplate, {
        name: "Prep Period",
        caption: schedule === null || schedule === void 0 ? void 0 : schedule.periods[classBlock.periodID],
        image: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-full h-full brightness-90 flex flex-row items-center justify-center relative",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute top-0 left-0 w-full h-full blur-lg",
                    style: {
                        ...(0,meshGradients/* meshifyColor */.n)(color)
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiBed */.pWL, {
                    className: "w-10 h-10 grayscale-[0.5]"
                })
            ]
        }),
        start: sb.from,
        end: sb.to
    });
    return null;
};

;// CONCATENATED MODULE: ./components/Dashboard/DashboardComponents/Schedule/DaySchedule/ClassBlockTypes/ClassBlock.tsx








const ClassBlock = (props)=>{
    const { classBlock  } = props;
    const community = (0,community_usePrimaryCommunity/* usePrimaryCommunity */.a)();
    const schedulePrefs = (0,useUserSchedulePrefs/* useUserSchedule */.W)(community === null || community === void 0 ? void 0 : community.community);
    const masterSched = (0,useMasterSchedule/* useMasterSchedule */.I)(community === null || community === void 0 ? void 0 : community.community);
    const scheduleMap = (0,react.useMemo)(()=>{
        const map = new Map();
        schedulePrefs === null || schedulePrefs === void 0 ? void 0 : schedulePrefs.classes.map((x)=>{
            map.set(x.periodID, x);
        });
        return map;
    }, [
        schedulePrefs
    ]);
    const currentPeriod = scheduleMap.get(classBlock.period);
    if (!currentPeriod) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomClassBlock, {
            classBlock: {
                name: masterSched === null || masterSched === void 0 ? void 0 : masterSched.periods[classBlock.period],
                type: "custom"
            },
            sb: classBlock
        });
    }
    switch(currentPeriod === null || currentPeriod === void 0 ? void 0 : currentPeriod.type){
        case "prep":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrepClassBlock, {
                classBlock: currentPeriod,
                sb: classBlock
            });
        case "class":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassClassBlock, {
                classBlock: currentPeriod,
                sb: classBlock
            });
        case "custom":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomClassBlock, {
                classBlock: currentPeriod,
                sb: classBlock
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    "Unknown block type ",
                    currentPeriod === null || currentPeriod === void 0 ? void 0 : currentPeriod.type,
                    " e ",
                    JSON.stringify(currentPeriod)
                ]
            });
    }
};
/* harmony default export */ var ClassBlockTypes_ClassBlock = ((/* unused pure expression or super */ null && (ClassBlock)));

;// CONCATENATED MODULE: ./components/Dashboard/DashboardComponents/Schedule/DaySchedule/DaySchedule.tsx







const DaySchedule = ()=>{
    const community = (0,community_usePrimaryCommunity/* usePrimaryCommunity */.a)();
    const masterSchedule = (0,useMasterSchedule/* useMasterSchedule */.I)(community === null || community === void 0 ? void 0 : community.community);
    const schedulePrefs = (0,useUserSchedulePrefs/* useUserSchedule */.W)(community === null || community === void 0 ? void 0 : community.community);
    const [scheduleDay, setScheduleDay] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        const update = ()=>{
            ScheduleClass/* ScheduleClass.getInstance */.L.getInstance().parseScheduleDay(masterSchedule !== null && masterSchedule !== void 0 ? masterSchedule : undefined).then((day)=>{
                setScheduleDay(day !== null && day !== void 0 ? day : null);
            });
        };
        update();
        const interval = setInterval(()=>{
            update();
        }, 1000);
        return ()=>clearInterval(interval);
    }, [
        masterSchedule,
        schedulePrefs
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative w-full h-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-4 h-full absolute top-0 left-0 overflow-auto pb-6 w-full scrollbar-none text-gray-900/80",
            children: scheduleDay === null || scheduleDay === void 0 ? void 0 : scheduleDay.map((classBlock, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ClassBlock, {
                    classBlock: classBlock
                }, index))
        })
    });
};

;// CONCATENATED MODULE: ./components/Dashboard/DashboardComponents/Schedule/Schedule.tsx



const Schedule = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full h-full flex flex-col gap-1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrentClassSchedule, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DaySchedule, {})
        ]
    });

;// CONCATENATED MODULE: ./pages/app/index.tsx










const Description = "Disadus is a tool that helps students increase their productivity and form school communities with their peers to achieve academic success!";
const MainApp = ()=>{
    const user = (0,useSelfInfo/* useCurrentUser */.x)();
    const router = (0,next_router.useRouter)();
    const [openPage, setOpenPage] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        if (user) {
        //   console.log(user))
        }
        if (user === null) {
            router.replace("/login");
        }
    //   console.log('user', user))
    }, [
        user
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full h-full flex flex-col",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-grow relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardBackground, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid inf:grid-cols-12 3xl:grid-cols-9 2xl:grid-cols-6 xl:grid-cols-2 xl:gap-4 md:grid-cols-1 w-full h-full z-10 absolute gap-12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-3 xl:col-span-1 ".concat(openPage !== 0 && "md:hidden"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Schedule, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-span-3 xl:col-span-1 ".concat(openPage !== 1 && "md:hidden"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardAnnouncements, {
                                        open: openPage,
                                        setOpen: setOpenPage
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MixedDashboardAndUpcoming, {
                                        open: openPage,
                                        setOpen: setOpenPage
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-3 2xl:hidden md:block ".concat(openPage !== 2 && "md:hidden"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardUpcoming, {
                                    open: openPage,
                                    setOpen: setOpenPage
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardComponents_MobileDashboardBottomBar, {
                open: openPage,
                setOpen: setOpenPage
            })
        ]
    });
};
/* harmony default export */ var app = (MainApp);


/***/ }),

/***/ 75344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ ScheduleClass; }
});

// EXTERNAL MODULE: ./node_modules/events/events.js
var events = __webpack_require__(17187);
var events_default = /*#__PURE__*/__webpack_require__.n(events);
// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(86353);
;// CONCATENATED MODULE: ./utils/types/scheduleTypes.ts
var ScheduleType;
(function(ScheduleType) {
    ScheduleType["abab"] = "abab";
    ScheduleType["weekly"] = "weekly";
    ScheduleType["daily"] = "daily";
})(ScheduleType || (ScheduleType = {}));

// EXTERNAL MODULE: ./utils/classes/Fetcher.ts
var Fetcher = __webpack_require__(69705);
// EXTERNAL MODULE: ./utils/classes/UserCommunities.ts
var UserCommunities = __webpack_require__(21524);
;// CONCATENATED MODULE: ./utils/classes/ScheduleClass.ts





class ScheduleClass extends (events_default()) {
    static getInstance() {
        if (!this.instance) {
            this.instance = new ScheduleClass();
        }
        return this.instance;
    }
    async linkSelf() {
        const communities = UserCommunities/* UserCommunities.getInstance */.z.getInstance();
        const update = ()=>{
            this.fetchAllSchedules();
        };
        communities.addListener("communitiesUpdate", update.bind(this));
    }
    loadSchedules() {
        this.masterSchedules = new Map();
        this.userSchedules = new Map();
        const cachedMasterSchedules = localStorage.getItem("masterSchedules");
        if (cachedMasterSchedules) {
            const parsedSchedules = JSON.parse(cachedMasterSchedules);
            for (const [key, value] of Object.entries(parsedSchedules)){
                this.masterSchedules.set(key, value);
            }
        }
        const cachedUserSchedules = localStorage.getItem("userSchedules");
        if (cachedUserSchedules) {
            const parsedSchedules1 = JSON.parse(cachedUserSchedules);
            for (const [key1, value1] of Object.entries(parsedSchedules1)){
                this.userSchedules.set(key1, value1);
            }
        }
    }
    saveSchedules() {
        //convert maps to objects
        const masterSchedules = {};
        for (const [key, value] of this.masterSchedules.entries()){
            if (!value) continue;
            masterSchedules[key] = value;
        }
        const userSchedules = {};
        for (const [key1, value1] of this.userSchedules.entries()){
            if (!value1) continue;
            userSchedules[key1] = value1;
        }
        localStorage.setItem("masterSchedules", JSON.stringify(masterSchedules));
        localStorage.setItem("userSchedules", JSON.stringify(userSchedules));
    }
    async fetchMasterSchedule(community) {
        const url = "".concat(constants/* API_DOMAIN */.hW, "/community/").concat(community, "/schedule");
        const response = await fetch(url);
        if (!response.ok) {
            this.masterSchedules.set(community, null);
            this.saveSchedules();
            this.emit("masterScheduleUpdate", null);
            return null;
        }
        const data = await response.json();
        if (response.status === 200) {
            this.masterSchedules.set(community, data);
            this.saveSchedules();
            this.emit("masterScheduleUpdate", data);
        }
        return data;
    }
    async fetchUserSchedule(community) {
        const url = "".concat(constants/* API_DOMAIN */.hW, "/community/").concat(community, "/schedule/@self");
        const response = await (0,Fetcher/* fetcher */._)(url, undefined, "important");
        if (!response.ok) {
            this.userSchedules.set(community, null);
            this.saveSchedules();
            this.emit("userScheduleUpdate", null);
            return null;
        }
        const data = await response.json();
        if (response.status === 200) {
            this.userSchedules.set(community, data);
            this.saveSchedules();
            this.emit("userScheduleUpdate", data);
        }
        return data;
    }
    async updateUserSchedule(community, schedule) {
        const url = "".concat(constants/* API_DOMAIN */.hW, "/community/").concat(community, "/schedule/@self");
        const response = await (0,Fetcher/* fetcher */._)(url, {
            method: "POST",
            body: JSON.stringify(schedule)
        }, "important");
        if (!response.ok) return false;
        await this.fetchUserSchedule(community);
        return true;
    }
    async fetchSchedulePair(community) {
        const masterSchedule = await this.fetchMasterSchedule(community);
        const userSchedule = await this.fetchUserSchedule(community);
        return {
            masterSchedule,
            userSchedule
        };
    }
    async fetchAllSchedules() {
        const communities = UserCommunities/* UserCommunities.getInstance */.z.getInstance();
        const communitiesList = communities.communities;
        const promises = [];
        for (const community of communitiesList.values()){
            promises.push(this.fetchSchedulePair(community.community));
        }
        const results = await Promise.all(promises);
        this.emit("schedulesFetched", results);
        return results;
    }
    async parseScheduleDay(schedule) {
        if (!schedule) return null;
        const { scheduleType  } = schedule.schedule;
        const currentScheduleDay = ()=>{
            if (scheduleType === ScheduleType.daily) {
                return schedule.schedule.classes;
            } else if (scheduleType === ScheduleType.weekly) {
                const sched = schedule.schedule;
                const today = new Date();
                const day = today.getDay();
                const days = [
                    "sunday",
                    "monday",
                    "tuesday",
                    "wednesday",
                    "thursday",
                    "friday",
                    "saturday"
                ];
                const currentday = days[day];
                return sched[currentday];
            } else if (scheduleType === ScheduleType.abab) {
                const today1 = new Date();
                const day1 = today1.getDay();
                const sched1 = schedule.schedule;
                return sched1.a;
            }
        };
        const classes = currentScheduleDay();
        return classes;
    }
    constructor(){
        super();
        this.loadSchedules();
        this.fetchAllSchedules();
        this.linkSelf();
    }
}


/***/ }),

/***/ 74398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useCommunityCourses; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _course_useUserCourses__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87247);


const useCommunityCourses = (communityID)=>{
    const userCourses = (0,_course_useUserCourses__WEBPACK_IMPORTED_MODULE_1__/* .useUserCourses */ .s)();
    const [courses, setCourses] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!communityID) return;
        setCourses(userCourses === null || userCourses === void 0 ? void 0 : userCourses.get(communityID));
        // alert('community courses changed')
        return ()=>{
        // setCourses(null)
        };
    }, [
        userCourses,
        communityID
    ]);
    return courses;
};


/***/ }),

/***/ 6734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ useMasterSchedule; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _classes_ScheduleClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75344);


const useMasterSchedule = (communityID)=>{
    const [schedule, setSchedule] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!communityID) return;
        const scheduleClass = _classes_ScheduleClass__WEBPACK_IMPORTED_MODULE_1__/* .ScheduleClass.getInstance */ .L.getInstance();
        const update = ()=>{
            const schedule = scheduleClass.masterSchedules.get(communityID);
            schedule && setSchedule(schedule);
        };
        scheduleClass.addListener("masterScheduleUpdate", update);
        update();
        return ()=>{
            scheduleClass.removeListener("masterScheduleUpdate", update);
        };
    }, [
        communityID
    ]);
    return schedule;
};


/***/ }),

/***/ 39575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ useUserSchedule; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _classes_ScheduleClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75344);


const useUserSchedule = (communityID)=>{
    const [schedule, setSchedule] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!communityID) return;
        const scheduleClass = _classes_ScheduleClass__WEBPACK_IMPORTED_MODULE_1__/* .ScheduleClass.getInstance */ .L.getInstance();
        const update = ()=>{
            const schedule = scheduleClass.userSchedules.get(communityID);
            schedule && setSchedule(schedule);
        };
        scheduleClass.addListener("userScheduleUpdate", update);
        update();
        return ()=>{
            scheduleClass.removeListener("userScheduleUpdate", update);
        };
    }, [
        communityID
    ]);
    return schedule;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3874,3662,2173,1265,1664,406,8450,848,6149,9774,2888,179], function() { return __webpack_exec__(89301); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);